import React, { useContext ,useEffect, useState,useRef} from 'react'
import { Context } from "../context/Context"
import {duaDetails ,duaAudios} from "../Database/Database";
import { useLocation, useParams} from 'react-router-dom'
import Loader from './Loader'

export default function DuaDetail() {
    const { lang,theme } = useContext(Context);
    const { id } = useParams();
    const location = useLocation();
    const { heading } = location.state;
    const playIcon = require("../assets/red/play_button_audio.png");
    const pauseIcon = require("../assets/red/pause_button_audio.png");

    const songs = [
       {fileSource : duaAudios[lang][id] ,name : "audio_track_1", id : "id_1" } ,
    ];

    const audioRef = useRef(null);
    const [isPlaying,setIsPlaying] = useState(false);
    const [currentSong,setCurrentSong] = useState(songs[0]);
    const [isLoading, setIsLoading] = useState(true);

    const endSongHandle = () => {
        // console.log("inside next auto play")
        let currentIndex = songs.findIndex((song) => song.name === currentSong.name);
        setCurrentSong(songs[currentIndex + 1]);

        if (isPlaying) {
          setTimeout(()=>audioRef.current.play(),100);
        }
    };

    useEffect(() => {
        if(isPlaying){
            audioRef.current.play()
        } else {
            audioRef.current.pause()
        }
        // console.log("is playing :",isPlaying)
    },[isPlaying])

    // Fallback timeout to hide loader if audio events don't fire
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (isLoading) {
                console.log("Timeout reached - hiding loader as fallback");
                setIsLoading(false);
            }
        }, 5000); // 5 second timeout

        return () => clearTimeout(timeout);
    }, [isLoading])

    // Reset loading state when audio source changes
    useEffect(() => {
        console.log("Audio source changed, setting loading to true");
        setIsLoading(true);
    }, [currentSong?.fileSource])

    const handlePlayPause = () => {
        if (isPlaying) {
            // console.log("inside play");
            audioRef.current.pause();
            setIsPlaying(false);
          } else {
            audioRef.current.play();
            setIsPlaying(true);
          }
    }

    const handleAudioPlay = () => {
        console.log("Audio started playing - hiding loader");
        setIsLoading(false);
    }

    const handleAudioLoadStart = () => {
        console.log("Audio loading started - showing loader");
        setIsLoading(true);
    }

    const handleAudioCanPlay = () => {
        console.log("Audio can play - hiding loader");
        setIsLoading(false);
    }

    const handleAudioError = () => {
        console.log("Audio error - hiding loader");
        setIsLoading(false);
    }

  return (
    <div className='min-h-screen h-full pt-20 max-width relative'>
        {isLoading && <Loader />}
        <div className='w-full flex'>
            <div className='ml-4 w-10 h-10' onClick={handlePlayPause} > <img src= {isPlaying ? pauseIcon : playIcon} /></div>
            <div className='w-3/4 text-center mx-auto ml-7'>
                <div className={`${theme === "red" ? "bg-red_surah_name_board py-2" :"bg-surah_name_board py-2" } bg-contain text-white font-bold bg-no-repeat w-3/4 h-20`}>{heading ? heading : ""}</div>
            </div>
        </div>
        <div className='bg-slate-100 border overflow-y-auto w-11/12 mx-auto'>
        {duaDetails[id]}
            {/* {
             duaDetails[id] && duaDetails[id].map((element, index) => {
                return ( */}
                    <div key={null} className='py-4 px-1 wrap'>
                        <div className='mt-2'>
                            <div className={`py-4 ${theme === "red" ? "bg-red_surah_number bg-contain": "bg-surah_number" }  bg-no-repeat bg-center `}>{null}</div>
                            <div className='my-2 text-yellow-500'>{duaDetails["ar"][id]}</div>
                            <div className='my-2'>{duaDetails[lang][id]}</div>
                            {/* <div className='my-2'>{element["fr"]}</div> */}
                        </div>
                        <audio
                            ref={audioRef}
                            src={currentSong?.fileSource}
                            onEnded={endSongHandle}
                            onPlay={handleAudioPlay}
                            onLoadStart={handleAudioLoadStart}
                            onCanPlay={handleAudioCanPlay}
                            onError={handleAudioError}
                            preload="auto"
                        ></audio>
                    </div>
                {/* )
               })
            } */}
        </div>
    </div>
  )
}
